<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="140px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('base.plant.plantNo')" prop="supplierCode">
                    <el-input v-model.trim="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('base.plant.plantName')" prop="supplierName">
                    <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="!isShowRadio">
                  <el-form-item :label="$t('common.status')" prop="status">
                    <el-select v-model="queryCondition.status" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="!isShowRadio">
                  <el-form-item :label="$t('base.plant.categoryLevel1Name')" prop="categoryLevel1Code">
                    <ic-select table="BASE" filterable field="CATEGORY_LEVEL1" clearable v-model="queryCondition.categoryLevel1Code" @change="queryCondition.categoryLevel2Code = null" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition v-if="!isShowRadio">
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('base.plant.categoryLevel2Name')" prop="categoryLevel2Code">
                      <ic-select table="BASE" filterable :field="queryCondition.categoryLevel1Code" clearable v-model="queryCondition.categoryLevel2Code" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>

            <span class="arrowDown" @click="isShow=!isShow" v-if="!isShowRadio">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row v-if="isShowRadio" type="flex" justify="start" style="margin-bottom:10px">
        <el-button size="mini" @click="onSelect" type="primary">选择</el-button>
      </el-row>
      <el-table sortable max-height="435" :data="plantList" ref="plantDataTable" border highlight-current-row class="table">
        <el-table-column v-if="isShowRadio" prop="name" :label="$t('common.select')" align="center" min-width="55">
          <template slot-scope="scope">
            <el-radio v-model="singleSelection" :label="scope.row">{{scope.row.supperSupplierId}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierCode" :label="$t('base.plant.plantNo')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierName" :label="$t('base.plant.plantName')" min-width="170px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="otherCode" :label="$t('base.plant.supplierNo')" min-width="90px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="otherName" :label="$t('base.plant.supplierName')" min-width="170px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="pickupPoint" :label="$t('base.pp.pickupPoint')" min-width="90px" v-if="!isShowRadio">
          <template slot-scope="scope">
            <el-link type="primary" @click="showSelectPickupPoint(scope.row)"> {{scope.row.pickupPoint==null?'请选择提货点':scope.row.pickupPoint}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" :label="$t('common.status')" min-width="80px" v-if="!isShowRadio"></el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('base.plant.categoryLevel2Name')" min-width='150px' sortable prop="categorys" v-if="!isShowRadio"></el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('common.operation')" v-if="!isShowRadio" min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" v-acl="PlantSensoryUsers" @click="editSensoryUser(scope.row.tmSupplierId)">{{$t("base.plant.userManage")}}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible="showSensoryPlantUserDialg" @close="showSensoryPlantUserDialg = false" width="300" append-to-body>
      <el-row>
        <el-button size="mini" type="primary" v-acl="PlantSaveSensoryPlantUsers" @click="addUser()">{{$t("common.addNew")}}</el-button>
        <el-button size="mini" type="primary" v-acl="PlantSaveSensoryPlantUsers" @click="saveUsers()">{{$t("common.save")}}</el-button>
      </el-row>
      <el-form :model="plantUsers" ref="plantUsersForm" :inline="true" style="margin-top:10px">
        <el-table :data="plantUsers" ref="plantUsersTable">
          <el-table-column show-overflow-tooltip :label="$t('sys.userList.userName')" prop="userName">
            <template slot-scope="scope">
              <el-form-item :prop="`[${scope.$index}].userName`" :rules="{required:true,message:$t('common.canNotBeEmpty')}">
                <el-input v-model="scope.row.userName"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('sys.userList.email')" prop="email">
            <template slot-scope="scope">
              <el-form-item :prop="`[${scope.$index}].email`" :rules="{required:true, type:'email', message:$t('sys.userList.inputEmail')}">
                <el-input v-model="scope.row.email"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('common.operation')" :prop="email" width="100">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" v-acl="PlantSaveSensoryPlantUsers" @click="delUser(scope.$index,scope.row.userName)">{{$t("common.del")}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="showSelPickupPointDialog" @close="showSelPickupPointDialog = false" append-to-body width="80%">
      <SelPickupPoint @subCallMethod="selectPickupPointMethod"></SelPickupPoint>
    </el-dialog>
  </div>
</template>
<script>
import { plantService } from "../../../api/base-data/plant";
import { inputChoiceService } from "../../../api/common/input-choice";
import { Message } from "element-ui";
import SelPickupPoint from './pickup-point-sel'
import commonFun from "@/utils/commonFun";
import dataTableUtils from "@/utils/dataTableUtils";
import IcSelect from "@/components/common/icSelect";
export default {
  name: 'plant',
  components: {
    IcSelect,
    SelPickupPoint
  },
  extends: dataTableUtils,
  props: ['isType','isTrigger'],
  data() {
    return {
      isShowRadio: false,//如果是SQMS点击Facility编码时则显示
      singleSelection: "",//选中的值
      isShow: false,//控制查询列表收缩展开
      totalCount: 0,
      plantList: [],
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        supplierCode: "",
        supplierName: "",
        status: "",
        categoryLevel1Code: '',
        categoryLevel2Code: ''
      },
      showSelPickupPointDialog: false,
      plantInfo: null,
      statusList: [],
      showSensoryPlantUserDialg: false,
      plantUsers: [],
      tmPlantId: null
    }
  },
  watch: {
    isType: {
      handler(newV) {
        console.log("GY🚀 ~ handler ~ newV:", newV);
        if (newV == 'SQMS') {
          this.isShowRadio = true
          this.queryCondition.status = '1'
        }
      },
      immediate: true
    },
    isTrigger: {
      handler(newV) {
        console.log("GY🚀 ~ isTrigger ~ newV:", newV);
        if (newV) {
          this.queryData(1);
        }
      },
      immediate: true
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    onSelect() {
      console.log('singleSelection', this.singleSelection)
      if (this.singleSelection) {
        this.$emit('setPlant', this.singleSelection)
      } else {
        this.$message.warning('请选择一条数据')
      }
    },
    addUser() {
      let plantUser = {
        userName: null,
        email: null
      }
      this.plantUsers.push(plantUser);
    },
    delUser(index, userName) {
      let that = this
      if (!commonFun.isEmpty(userName)) {
        that.$confirm(that.$t('common.delConfirm'), that.$t('common.tips'), {
          confirmButtonText: that.$t('common.confirm'),
          cancelButtonText: that.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          that.plantUsers.splice(index, 1);
        }).catch(() => {

        });
      } else {
        that.plantUsers.splice(index, 1);
      }
    },
    saveUsers() {
      /* 允许没有人员时的保存               if (commonFun.isEmpty(this.plantUsers)) {
                          Message.error(this.$t("common.canNotBeEmpty"));
                          return;
                      }*/
      this.$refs.plantUsersForm.validate().then(valid => {
        if (valid) {
          plantService.saveSensoryPlantUsers(this.tmPlantId, this.plantUsers).then(res => {
            if (res.code == 200) {
              Message.success(this.$t("common.saveSuccess"));
            }
          });
        }
      });
    },
    editSensoryUser(plantId) {
      plantService.listUsers(plantId).then(res => {
        this.plantUsers = res.data;
        this.tmPlantId = plantId;
        this.showSensoryPlantUserDialg = true;
      })
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      plantService.getPlantData(this.queryCondition).then((res) => {
        this.plantList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    //分页查询页数变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //分页查询每页显示数量变化
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        supplierCode: "",
        supplierName: "",
        status: "",
        categoryLevel1Code: '',
        categoryLevel2Code: ''
      }
      this.queryData()
    },
    showSelectPickupPoint: function (row) {
      if (this.actionCheck.actionCheck('PlantPickupPoint') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.plantInfo = row;
      this.showSelPickupPointDialog = true;
    }
    ,
    selectPickupPointMethod: function (pickupPoint) {
      if (this.plantInfo.tmPickupPointId != pickupPoint.tmPickupPointId) {
        let oldPointName = this.plantInfo.pickupPoint;
        let oldPointId = this.plantInfo.tmPickupPointId;
        this.plantInfo.pickupPoint = pickupPoint.pickupPoint;
        this.plantInfo.tmPickupPointId = pickupPoint.tmPickupPointId;
        plantService.updatePlantPickupPoint(this.plantInfo).then((res) => {
          if (res.meta.success) {
            Message({ message: this.$t('common.updateSuccess'), type: "success" });
            this.showSelPickupPointDialog = false;
          }
        }).catch(() => {
          this.plantInfo.pickupPoint = oldPointName;
          this.plantInfo.tmPickupPointId = oldPointId;
          this.showSelPickupPointDialog = false;
        });
      } else {
        this.showSelPickupPointDialog = false;
        Message({ message: this.$t('common.updateSuccess'), type: "success" });
      }
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    }
  }
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
.el-select {
  width: 100%;
}
</style>
